import React, {Component} from 'react';
import {hot} from 'react-hot-loader';
import {Provider} from 'react-redux';
import {Route, Switch} from 'react-router-dom';
import b_ from 'b_';

import SurveyPreview from 'client/common/components/survey-preview';
import getStore from 'client/common/store';
import reducer from 'client/common/store/reducers/quicksurvey';
import rootSaga from 'client/common/store/saga/quicksurvey';
import {QuicksurveyStore} from 'client/common/types';
import {BundleProps} from 'client/common/types/bundle';
import {renderBundle} from 'client/common/utils/bundle';
import {UserProvider} from 'client/common/contexts/user';
import ChoosePaymentData from './choose-payment-data';
import OrgAccessPage from './org-access';
import SurveyCreate from './survey-create';
import List from './list';

import '../common/utils/bundle.css';

const b = b_.with('app');

class QSBundle extends Component<BundleProps> {
    store = getStore<QuicksurveyStore>(this.props.state, {reducer, rootSaga});

    render() {
        return (
            <Provider store={this.store}>
                <UserProvider value={this.props.state.user}>
                    <div className={b()}>
                        <Switch>
                            <Route exact path={['/quicksurvey']}>
                                <SurveyCreate />
                            </Route>
                            <Route path={['/quicksurvey/preview/:slug']}>
                                <SurveyPreview />
                            </Route>
                            <Route exact path={['/quicksurvey/list']}>
                                <List />
                            </Route>
                            <Route exact path={['/choose-payment-data']}>
                                <ChoosePaymentData />
                            </Route>
                            <Route exact path={['/org/access']}>
                                <OrgAccessPage />
                            </Route>
                        </Switch>
                    </div>
                </UserProvider>
            </Provider>
        );
    }
}

const QuicksurveyBundle = hot(module)(QSBundle);

export default renderBundle(QuicksurveyBundle);
